import Drawer from '@navi/web-ui/lib/primitives/Drawer/Drawer';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import { RootState } from '@cp/src/store';
import DrawerHeader from '../DrawerHeader';
import RaiseRequestIcon from '@cp/src/assets/icons/RaiseRequestIcon';
import CustomerDetail from '../CustomerDetail';
import ActivityLog from '../ActivityLog';
import { useParams } from 'react-router-dom';
import ReceiveRequestIcon from '@cp/src/assets/icons/ReceiveRequestIcon';
import { ISingleTicketDrawer } from '../../types';
import { Typography } from '@navi/web-ui/lib/primitives';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { useEffect } from 'react';

const SingleTicketDrawer = (props: ISingleTicketDrawer) => {
  const { toggleDrawer, isOpen, ticket, isLoading } = props;
  const { loanId } = useParams();

  const user = useSelector((state: RootState) => state?.common?.userData);

  const isTicketRaisedByLoggedInUser = ticket?.requestedBy?.referenceId === user?.referenceId;
  const { address = '' } = ticket?.supportRequestDetails || {};

  useEffect(() => {
    if (isOpen) {
      addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_TASK_DETAIL_LOAD_SUCCESSFUL, {
        ticketId: ticket.referenceId
      });
    }
  }, [isOpen]);

  return (
    <form>
      <Drawer
        usePadding={false}
        className="!w-[550px]"
        headerContainerClasses={styles.drawerHeaderContainer}
        open={isOpen}
        onClose={toggleDrawer}
        headerText={
          <DrawerHeader
            loading={isLoading}
            icon={isTicketRaisedByLoggedInUser ? <RaiseRequestIcon /> : <ReceiveRequestIcon />}
            title={ticket?.requestTypeLabel}
            subTitle={
              ticket?.requestedBy?.name ? `Task created by ${ticket?.requestedBy?.name}` : ''
            }
          />
        }
      >
        {isOpen && (
          <div className="pt-4">
            {!loanId ? <CustomerDetail ticket={ticket} loading={isLoading} /> : null}
            {address ? (
              <div className={`px-4 mb-4 mt-${loanId ? '0' : '4'}`}>
                <Typography variant="h4">Added address</Typography>
                <Typography variant="p4" className={styles.breakWord}>
                  {address}
                </Typography>
              </div>
            ) : null}
            <ActivityLog ticket={ticket} loading={isLoading} />
          </div>
        )}
      </Drawer>
    </form>
  );
};

export default SingleTicketDrawer;
